const getQueryErrorPermissionDenied = (): string => {
  return "Ошибка авторизации. Отсутствуют права для редактирования данной конференции";
};

export default getQueryErrorPermissionDenied;
